// extracted by mini-css-extract-plugin
export default {"emod_ques":"Emod_emod_ques__9p5m+","form-group":"Emod_form-group__EeiUq","dateRate1":"Emod_dateRate1__kYVih","emod_ques_heading":"Emod_emod_ques_heading__RW2+O"};